export default __webpack_public_path__ + "static/media/call-black.192a76f1.svg";